<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
       
                <div class="modal-title">Add Ticket Category</div>
            
 </div>
 <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
      <div class="row mar-lft-rgt-0">
    <div class="col-sm-6 pad-15 text-center">
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="updateStatusSelected"
                      (change)="onChangeUpdateStatus($event.target.selectedIndex)">
              <option *ngFor="let obj of updateStatus" [value]="obj.id">{{obj.name}}</option>
            </select>
          </div>
      <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                               (complete)="onFileComplete($event)" [formData]="formData"></app-material-fileupload>
    </div>
    <div class="col-sm-6 pad-15 text-center">
      <div class="form-group">
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelectedForTemplate"
                    (change)="onTicketChange($event.target.selectedIndex)">
          <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
        </select>
      </div>
      <div class="form-group">
        <mat-checkbox [(ngModel)]="enablePriority">Priority Required ?</mat-checkbox>
      </div>
      <button [disabled]="templatebtndisabled" type="button" class="btn btn-primary radius-0" (click)="downloadTemplate()">Generate Template</button>
      <!--<div class="pad-5 text-center" [innerHTML]="templateDownloadMessage"></div>-->
        <div class="pad-5 text-center download" *ngIf="showDownload"><a (click)="downloadFile()">Download</a></div>
    </div>
  </div>
      <div class="row mar-lft-rgt-0">
    <div class="col-sm-6 pad-15 text-center" [innerHTML]="uploadSuccessMessage"></div>
  </div>
  </div>
  </ng-template>
